import { countrySelectValidationSchema } from "../../../../components/AuthForm/components/CountrySelect/validation.js";
import { emailInputValidationSchema } from "../../../../components/AuthForm/components/EmailInput/validation.js";
import { passwordInputValidationSchema } from "../../../../components/AuthForm/components/PasswordInput/validation.js";

export const signupValidationSchema = emailInputValidationSchema.concat(passwordInputValidationSchema.concat(countrySelectValidationSchema));
